<template>
  <div class="active">
    <div
      class="li"
      v-for="(item, index) in gameList"
      :key="index"
      @click="toActiveDetail(item.id)"
    >
      <div class="li_img">
        <img :src="item.banner" alt="" />
      </div>
      <div class="li_bot">
        <div class="li_bot_l">
          <span class="li_title">{{ item.title }}</span>
          <span class="li_time">{{ item.activityTime }}</span>
        </div>
        <div :class="'li_start' + item.status">
          <img src="../assets/img/time_normal.png" alt="" />
          <span v-if="item.status == 0">未开始</span>
          <span v-else-if="item.status == 1">正在进行</span>
          <span v-else-if="item.status == 2">已结束</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Details from "@/components/detail.vue";
export default {
  name: "active",
  props: ["list"],
  components: {
    Details,
  },
  data() {
    return {
      gameList: [],
    };
  },
  created() {},
  mounted() {
    this.gameList = this.list;
  },
  methods: {
    toActiveDetail(id) {
      let data = {
        activityId: id,
      };
      this.$api.reqData("/api/v1/index/getActivityInfo", data).then(
        (res) => {
          if (res.code == 200) {
            this.$store.dispatch("GetDetailMsgFun", JSON.stringify(res.data));
            this.$store.dispatch("IsShowDetailFun", true);
          } else {
            this.$toast.text(res.msg);
          }
        },
        (res) => {
          this.$toast.text(res.msg);
        }
      );
    },
    getActiveMsg() {},
  },
};
</script>
<style lang="scss" scoped>
@mixin flex_box(
  $flex-direction: row,
  $justify-content: none,
  $align-items: none
) {
  display: flex;
  flex-direction: $flex-direction;
  justify-content: $justify-content;
  align-items: $align-items;
}
.active {
  @include flex_box(column, none, stretch);
  background-color: #ededed;
  .li {
    @include flex_box(column, center, stretch);
    margin-bottom: 0.1rem;
    background-color: #fff;
  }
  .li_img {
    margin-top: 0.2rem;
    height: 3.6rem;
    overflow: hidden;
    border-radius: 6px;
    @include flex_box(row, center, flex-start);
    img {
      border-radius: 6px;
      width: 7.2rem;
      height: auto;
    }
  }
  .li_bot {
    // height: 0.94rem;
    padding: 0.1rem 0.16rem;
    @include flex_box(row, space-between, center);
  }
  .li_bot_l {
    @include flex_box(column, center, flex-start);
  }
  .li_title {
    color: #656565;
    font-size: 14px;
    text-align: left;
  }
  .li_time {
    margin-top: 0.06rem;
    font-size: 12px;
    color: #999999;
    transform: scale(0.9);
    transform-origin: 0 center;
    text-indent: 0.1rem;
  }
  .li_start0,
  .li_start1,
  .li_start2 {
    @include flex_box(row, center, center);
    // width: 1.08rem;
    padding: 0 0.1rem;
    height: 0.46rem;
    width: 1.26rem;
    min-width: 1.26rem;
    border-radius: 4px;
    color: #fff;
    font-size: 12px;
    img {
      width: 0.24rem;
      height: 0.24rem;
      margin-right: 0.1rem;
      line-height: 0.46rem;
    }
  }
  
  .li_start0 {
    background-color: #f05b5b;
  }
  .li_start1 {
    background-color: #ff913a;
  }
  .li_start2 {
    background-color: #bebebe;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/active.vue